import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import type {FaqCategoryKey} from 'app/utils/knowledgeCenter/categories';
import type {FaqArticleLink} from 'app/utils/knowledgeCenter/faqGrouping';

interface Props {
    title: string
    icon: React.ReactElement
    articles: FaqArticleLink[]
    categoryKey?: FaqCategoryKey
}

const buildPanelMeta = (articlesCount: number, categoryKey?: FaqCategoryKey): string => {
    const countLabel = I18n.t('knowledge_center.articles_count', {count: articlesCount});

    if (!categoryKey) {
        return countLabel;
    }

    return `${countLabel} · ${I18n.t(`knowledge_center.category_descriptions.${categoryKey}`)}`;
};

const KnowledgeCenterArticlePanel = ({
    title,
    icon,
    articles,
    categoryKey
}: Props): React.ReactElement => <div className="knowledge-center__category-panel">
    <div className="knowledge-center__category-panel-header">
        <span className="knowledge-center__category-icon">
            {icon}
        </span>
        <div className="knowledge-center__category-panel-heading">
            <h1 className="knowledge-center__category-panel-title">{title}</h1>
            <p className="knowledge-center__category-panel-meta">
                {buildPanelMeta(articles.length, categoryKey)}
            </p>
        </div>
    </div>
    {articles.length > 0
        ? <ul className="knowledge-center__category-articles">
            {articles.map((article: FaqArticleLink) => <li key={article.name}>
                <Link
                    to={getLinkPath(`/faq/${article.name}`)}
                    className="knowledge-center__category-article-row"
                >
                    <span className="knowledge-center__category-article-title">
                        {article.title}
                    </span>
                    <span
                        className="knowledge-center__category-article-chevron"
                        aria-hidden
                    />
                </Link>
            </li>)}
        </ul>
        : <p className="knowledge-center__empty knowledge-center__category-panel-empty">
            {I18n.t('global.nothing_found')}
        </p>}
</div>;

export default KnowledgeCenterArticlePanel;
